import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";

import { ComingSoonCard } from "./ComingSoonCard";
import type { FeatureFlag } from "./flags";

/**
 * What a flag-gated address shows (T11-09 route guard): the page frame + the "coming soon" card
 * instead of a 404 — a bookmarked eBay link says "later", not "broken".
 */
export function ComingSoonPage({
  features,
  titleKey,
}: {
  features: readonly FeatureFlag[];
  titleKey?: string;
}) {
  const { t } = useTranslation();
  const title = titleKey ? t(titleKey) : t("states.coming_soon_title");
  return (
    <div className="flex flex-col gap-6" data-page="coming-soon">
      <PageHeader title={title} description={t("flags.page_intro")} />
      <div className="grid gap-3 md:grid-cols-2">
        {features.map((feature) => (
          <ComingSoonCard key={feature} feature={feature} />
        ))}
      </div>
      <div>
        <Button asChild variant="outline">
          <Link to="/">{t("states.building_action")}</Link>
        </Button>
      </div>
    </div>
  );
}
